import styles from './styles.module.css';
import { Button, Text } from '@/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export default function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div role='alert' className={styles.container}>
      <div className={styles.errorsContainer}>
        <Text size='l' color='base-blue'>
          {t('Shared.something_went_wrong')}:
        </Text>
        <pre>
          <Text size='l' color='base-blue'>
            {error.message}
          </Text>
        </pre>
        <Button
          variant='primary'
          size='large'
          onClick={() => {
            resetErrorBoundary();
            navigate('/');
          }}
        >
          {t('Shared.go_home')}
        </Button>
      </div>
    </div>
  );
}
